import {
  Box,
  Checkbox,
  FormControl,
  Grid2,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ORLogo from "../../assets/ORhorizontal.svg";
import "./signup.css";
import MUIButton from "../../reusable_components/components/MUIButton";
import MuiCancelButton from "../../reusable_components/components/MuiCancelButton";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useContext, useState } from "react";
import {
  useSignPositionLevelDropDownQuery,
  useSignUpMutation,
  useSignWorkCategoryDropDownQuery,
} from "../../redux/Signup/signup.api";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import Dropdown from "../../reusable_components/components/Dropdown";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import dayjs from "dayjs";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Loader from "../../reusable_components/components/Loader";

const SignUp = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("First Name is required")
      .matches(/^[A-Za-z\s]+$/, "must only contain letters"),
    address: Yup.string().required("Address is Required"),
    city: Yup.string().required("City is Required"),
    email: Yup.string()
      .email("Enter Valid Email")
      .required("Please Enter the email")
      .test("Enter Valid Email", "Enter Valid Email", (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
      }),
    password: Yup.string()
      .required("Password is Required")
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}$/,
        "Password must contain atleast 1 upper and lowercase letter, 1 number, and 1 special character and min of 8 characters"
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Password does not match")
      .required("Confirm Password is Required "),
    state: Yup.string().required("State is Required"),
    pincode: Yup.string().required("Pincode is Required"),
    contactNumber: Yup.string().required("Contact Number  is Required"),
    // .min(10, "Alternate number must be exactly 10 digits")
    // .max(10, "Alternate number must be exactly 10 digits"),
    gender: Yup.string().required("Gender is Required"),
    dateOfBirth: Yup.date()
      .nullable()
      .required("Date of Birth is Required")
      .max(new Date(), "Date of Birth cannot be in the future"),
    alternateEmail: Yup.string()
      .notRequired()
      .test(
        "valid-and-different-email",
        "Enter a valid alternate email and it must be different from primary email",
        function (value) {
          const email = this.resolve(Yup.ref("email"));
          if (!value) return true; // allow empty
          const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          return isValidEmail && value !== email;
        }
      ),

    alternateNumber: Yup.string()
      .notRequired()
      .test(
        "valid-and-different-number",
        "Alternate number must be  different from contact number",
        function (value) {
          const contactNumber = this.resolve(Yup.ref("contactNumber"));
          if (!value) return true; // allow empty
          return value !== contactNumber;
        }
      ),
    companyName: Yup.string()
      .notRequired()
      .test("is-letters-only", "must only contain letters", (value) => {
        if (!value) return true; // allow empty (not required)
        return /^[A-Za-z0-9\s]+$/.test(value);
      }),
    category: Yup.array()
      .min(1, "Select at least one category")
      .required("Category is required"),
    level: Yup.array()
      .min(1, "Select at least one level")
      .required("Level is required"),
  });

  const resolver = yupResolver(validationSchema);

  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm({
    mode: "onChange",
    resolver,
    defaultValues: {
      name: "",
      address: "",
      city: "",
      email: "",
      password: "",
      confirmPassword: "",
      state: "",
      pincode: "",
      contactNumber: "",
      gender: "",
      dateOfBirth: null,
      alternateEmail: "",
      alternateNumber: "",
      companyName: "",
      category: [1, 2],
      level: [1, 2, 3, 4],
    },
  });

  const { Snackbar } = useContext(SnackbarContext);

  const [SignUp] = useSignUpMutation();
  const { data: getWorkCategoryDropDown } = useSignWorkCategoryDropDownQuery();
  const { data: getPositionLevelDropDown } = useSignPositionLevelDropDownQuery();
  const [companyName, setCompanyName] = useState("");
  const [alternateNumber, setAlternateNumber] = useState("");
  const [alternateEmail, setAlternateEmail] = useState("");
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [category, setCategory] = useState(
    getWorkCategoryDropDown?.response || []
  );
  const [level, setLevel] = useState(getPositionLevelDropDown?.response || []);
  const [selectedKeywordIds, setSelectedKeywordIds] = useState([1,2]);
  const [selectedlevelIds, setSelectedlevelIds] = useState([1, 2, 3, 4]);
  const [confirmPasswordInteracted, setConfirmPasswordInteracted] =
    useState(false);
  const [showOverAllLoader, setShowOverAllLoader] = useState(false);

  const handleCompanyNameChange = (e) => {
    const value = e.target.value;
    setCompanyName(value);
  };

  const handleAlternateNoChange = (e) => {
    const value = e.target.value;
    setAlternateNumber(value);
  };

  // const handleAlternateEmailChange = (e) => {
  //     const value = e.target.value
  //     setAlternateEmail(value)
  // }
  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword((show) => !show);
  };
  const onSubmit = async (data) => {
    try {
      const payload = {
        address: data?.address,
        alternateEmail: data?.alternateEmail || "",
        alternatePhone: data?.alternateNumber || "",
        city: data?.city,
        companyName: data?.companyName || "",
        confirmPassword: data?.confirmPassword,
        contactNumber: data?.contactNumber,
        email: data?.email,
        name: data?.name,
        password: data?.password,
        pincode: data?.pincode,
        state: data?.state,
        gender: data?.gender,
        dob: data?.dateOfBirth
          ? dayjs(data?.dateOfBirth).format("DD-MM-YYYY")
          : null,
        workCategoryIds: selectedKeywordIds || [],
        jobPositionLevels: selectedlevelIds || [],
      };
      setShowOverAllLoader(true);
      const response = await SignUp(payload).unwrap();
      setShowOverAllLoader(false);
      if (response?.status === 200) {
        Snackbar("Registration Details Received", "success");
        setShowOverAllLoader(false);
        navigate("/");
      } else if (response?.status === "error") {
        Snackbar(response?.data?.error_message, "error");
        setShowOverAllLoader(false);
      }
    } catch (err) {
      Snackbar("Network error", "error");
      setShowOverAllLoader(false);
    }
  };

  const genderOptions = [
    {
      id: "Male",
      label: "Male",
    },
    {
      id: "Female",
      label: "Female",
    },
    {
      id: "Transgender",
      label: "Transgender",
    },
  ];

  //   const category = [
  //     {
  //       id: 1,
  //       label: "IT",
  //     },
  //     {
  //       id: 2,
  //       label: "Non IT",
  //     },
  //     {
  //       id: 3,
  //       label: "BPO",
  //     },
  //   ];

  return (
    <Box>
      {showOverAllLoader ? <Loader /> : ""}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid2
          marginTop={2}
          marginLeft={2}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <img
            src={ORLogo}
            alt="Your Logo"
            style={{ width: "20%", height: "20%" }}
          />
        </Grid2>

        <Grid2
          item
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            marginTop: 1,
          }}
        >
          <Typography sx={{ fontSize: "22px", fontWeight: "bold" }}>
            Become a Open Recruiter
          </Typography>
          <Typography sx={{ fontSize: "17px", fontWeight: "bold" }}>
            Please fill the below form to share your details and our team will
            contact you promptly
          </Typography>
        </Grid2>

        <Box className="signUpBoxContainer">
          <Grid2
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <Grid2
              item
              sx={{
                display: "flex",
                flexDirection: !isSmallScreen ? "row" : "column",
                justifyContent: "space-between",
              }}
            >
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Name <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  control={control}
                  name={"name"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter name"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={errors?.name ? errors?.name?.message : ""}
                    />
                  )}
                />
              </Grid2>
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Email <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  control={control}
                  name={"email"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter email"
                      onChange={(e) => {
                        field.onChange(e);
                        trigger("alternateEmail");
                      }}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={errors?.email ? errors?.email?.message : ""}
                    />
                  )}
                />
              </Grid2>
            </Grid2>

            <Grid2
              item
              sx={{
                display: "flex",
                flexDirection: !isSmallScreen ? "row" : "column",
                justifyContent: "space-between",
              }}
            >
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Company Name
                </InputLabel>
                <Controller
                  control={control}
                  name={"companyName"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter company name"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={
                        errors?.companyName ? errors?.companyName?.message : ""
                      }
                    // onChange={handleCompanyNameChange}
                    />
                  )}
                />
              </Grid2>
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Contact Number <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  control={control}
                  name={"contactNumber"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter contact number"
                      onChange={(e) => {
                        field.onChange(e); // update field value
                        trigger("alternateNumber"); // manually trigger validation of alternate number
                      }}
                      type="number"
                      inputProps={{
                        maxLength: 10,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}
                      sx={{
                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={
                        errors?.contactNumber
                          ? errors?.contactNumber?.message
                          : ""
                      }
                    />
                  )}
                />
              </Grid2>
            </Grid2>

            <Grid2
              item
              sx={{
                display: "flex",
                flexDirection: !isSmallScreen ? "row" : "column",
                justifyContent: "space-between",
              }}
            >
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Address <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <div style={{ width: "100%" }}>
                  <Controller
                    control={control}
                    name={"address"}
                    render={({ field }) => (
                      <textarea
                        {...field}
                        className="jobPostingTextAreas"
                        placeholder="Enter address"
                        style={{ width: "100%", resize: "none" }}
                      />
                    )}
                  />
                  {errors?.address && (
                    <div style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors?.address?.message}
                    </div>
                  )}
                </div>
              </Grid2>
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Gender <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Controller
                    control={control}
                    name="gender"
                    render={({ field }) => (
                      <Dropdown
                        {...field}
                        className="dropdown"
                        displayEmpty
                        placeholder="Select gender"
                        valueKey="id"
                        labelKey="label"
                        options={genderOptions || []}
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                      />
                    )}
                  />
                  {errors?.gender?.message && (
                    <span style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors?.gender?.message}
                    </span>
                  )}
                </Box>
              </Grid2>
            </Grid2>
            <Grid2
              item
              sx={{
                display: "flex",
                flexDirection: !isSmallScreen ? "row" : "column",
                justifyContent: "space-between",
              }}
            >
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Date of Birth <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  name="dateOfBirth"
                  control={control}
                  render={({ field }) => (
                    <MuiDatePicker
                      {...field}
                      value={field.value ? dayjs(field.value) : null}
                      onChange={(date) => field.onChange(date)}
                      maxDate={dayjs().subtract(18, "year")}
                      slotProps={{
                        textField: {
                          error: !!errors.dateOfBirth,
                          helperText: errors.dateOfBirth?.message,
                          FormHelperTextProps: {
                            sx: { color: "red !important" },
                          },
                        },
                      }}
                    />
                  )}
                />
              </Grid2>
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  City <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  control={control}
                  name={"city"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter city"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={errors?.city ? errors?.city?.message : ""}
                    />
                  )}
                />
              </Grid2>
            </Grid2>

            <Grid2
              item
              sx={{
                display: "flex",
                flexDirection: !isSmallScreen ? "row" : "column",
                justifyContent: "space-between",
              }}
            >
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  State <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  control={control}
                  name={"state"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter state"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={errors?.state ? errors?.state?.message : ""}
                    />
                  )}
                />
              </Grid2>
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Pincode <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  control={control}
                  name={"pincode"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      className="textfields"
                      placeholder="Enter pincode"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={
                        errors?.pincode ? errors?.pincode?.message : ""
                      }
                    />
                  )}
                />
              </Grid2>
            </Grid2>

            <Grid2
              item
              sx={{
                display: "flex",
                flexDirection: !isSmallScreen ? "row" : "column",
                justifyContent: "space-between",
              }}
            >
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Password <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  control={control}
                  name={"password"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter password"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      autoComplete="new-password"
                      helperText={
                        errors?.password ? errors?.password?.message : ""
                      }
                      type={showPassword ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={handleClickShowPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid2>
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Confirm Password <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  control={control}
                  name={"confirmPassword"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter confirm password"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      autoComplete="new-password"
                      helperText={
                        errors?.confirmPassword
                          ? errors?.confirmPassword?.message
                          : ""
                      }
                      type={showConfirmPassword ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showConfirmPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={handleClickShowConfirmPassword}
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid2>
            </Grid2>

            <Grid2
              item
              sx={{
                display: "flex",
                flexDirection: !isSmallScreen ? "row" : "column",
                justifyContent: "space-between",
              }}
            >
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Alternate Number
                </InputLabel>
                <Controller
                  control={control}
                  name={"alternateNumber"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      type="number"
                      placeholder="Enter alternate number"
                      inputProps={{
                        maxLength: 6,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}
                      sx={{
                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={
                        errors?.alternateNumber
                          ? errors?.alternateNumber?.message
                          : ""
                      }
                    />
                  )}
                />
              </Grid2>
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Alternate Email
                </InputLabel>
                <Controller
                  control={control}
                  name={"alternateEmail"}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="textfields"
                      placeholder="Enter alternate email"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          color: "red",
                          marginLeft: "-1px",
                        },
                      }}
                      helperText={
                        errors?.alternateEmail
                          ? errors?.alternateEmail?.message
                          : ""
                      }
                    />
                  )}
                />
              </Grid2>
            </Grid2>

            <Grid2
              item
              sx={{
                display: "flex",
                flexDirection: !isSmallScreen ? "row" : "column",
                justifyContent: "space-between",
              }}
            >
              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Work Category <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Controller
                    control={control}
                    name="category"
                    render={({ field }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                        }}
                      >
                        {getWorkCategoryDropDown?.response.map((option) => (
                          <Box
                            key={option.workCategoryId}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              width: "40%",
                            }}
                          >
                            <Checkbox
                              checked={field.value?.includes(
                                option.workCategoryId
                              )}
                              onChange={(e) => {
                                let newValue;
                                if (e.target.checked) {
                                  newValue = [
                                    ...(field.value || []),
                                    option.workCategoryId,
                                  ];
                                } else {
                                  newValue = field.value.filter(
                                    (id) => id !== option.workCategoryId
                                  );
                                }

                                field.onChange(newValue);
                                setSelectedKeywordIds(newValue);
                              }}
                            />
                            {option.workCategoryName}
                          </Box>
                        ))}
                      </Box>
                    )}
                  />
                  {errors?.category?.message && (
                    <span style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors?.category?.message}
                    </span>
                  )}
                </Box>
              </Grid2>

              <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Position Levels <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Box sx={{ width: "100%" }}>
                  <Controller
                    control={control}
                    name="level"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          multiple
                          {...field}
                          value={field.value || []} // ensure empty array as default
                          onChange={(e) => (field.onChange(e.target.value), setSelectedlevelIds(e.target.value))} // update react-hook-form
                          displayEmpty
                          renderValue={(selected) =>
                            selected?.length === 0 ? (
                              <span
                                style={{ color: "#a2a2a2", fontSize: "14px" }}
                              >
                                Select Levels
                              </span>
                            ) : (
                              selected
                                .map(
                                  (id) =>
                                    getPositionLevelDropDown?.response.find(
                                      (level) => level.jobPositionLevelId === id
                                    )?.jobPositionLevelName
                                )
                                .join(", ")
                            )
                          }
                          sx={{
                            height: "35px",
                            fontSize: "14px",
                            borderRadius: "10px",
                          }}
                        >
                          {getPositionLevelDropDown?.response.map((option) => (
                            <MenuItem
                              key={option.jobPositionLevelId}
                              value={option.jobPositionLevelId}
                              sx={{
                                margin: "5px",
                                borderRadius: "7px",
                                fontSize: "14px",
                              }}
                            >
                              <Checkbox
                                checked={selectedlevelIds?.includes(
                                  option.jobPositionLevelId
                                )}
                                onChange={(e) => {
                                  let newValue;
                                  if (e.target.checked) {
                                    newValue = [
                                      ...(field.value || []),
                                      option.jobPositionLevelId,
                                    ];
                                  } else {
                                    newValue = field.value.filter(
                                      (id) => id !== option.jobPositionLevelId
                                    );
                                  }
                                  field.onChange(newValue);
                                  setSelectedlevelIds(newValue);
                                }}
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 18 },
                                  padding: 0.2,
                                }}
                              />
                              {option.jobPositionLevelName}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors?.level?.message && (
                          <span style={{ color: "red", fontSize: "0.8rem" }}>
                            {errors.level.message}
                          </span>
                        )}
                      </FormControl>
                    )}
                  />
                </Box>
              </Grid2>
              {/* <Grid2
                item
                sx={{
                  display: !isSmallScreen ? "flex" : "",
                  alignItems: "center",
                  width: !isSmallScreen ? "40%" : "100%",
                  marginTop: "20px",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Level <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Controller
                    control={control}
                    name="level"
                    render={({ field }) => (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        {getPositionLevelDropDown?.response.map((option) => (
                          <label
                            key={option.jobPositionLevelId}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Checkbox
                              checked={field.value?.includes(
                                option.jobPositionLevelId
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  field.onChange([
                                    ...(field.value || []),
                                    option.jobPositionLevelId,
                                  ]);
                                } else {
                                  field.onChange(
                                    field.value.filter(
                                      (id) => id !== option.jobPositionLevelId
                                    )
                                  );
                                }
                              }}
                            />
                            {option.jobPositionLevelName}
                          </label>
                        ))}
                      </Box>
                    )}
                  />
                  {errors?.level?.message && (
                    <span style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors?.level?.message}
                    </span>
                  )}
                </Box>
              </Grid2> */}
            </Grid2>
            {/* Sub container 1 */}
            {/* <Grid2 item container rowGap={2} sx={{ display: 'flex', flexDirection: 'column', width: !isSmallScreen ? '40%' : '100%' }}>
                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    control={control}
                                    name={"name"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter name"
                                            sx={{
                                                '& .MuiFormHelperText-root': {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.name ? errors?.name?.message : ""}
                                        />
                                    )}
                                />
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Company Name</InputLabel>
                                <Controller
                                    control={control}
                                    name={"companyName"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter company name"
                                            sx={{
                                                '& .MuiFormHelperText-root': {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.companyName ? errors?.companyName?.message : ""}
                                        // onChange={handleCompanyNameChange}
                                        />
                                    )}
                                />
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "" }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Address <span style={{ color: 'red' }}>*</span></InputLabel>
                                <div style={{ width: '100%' }}>
                                    <Controller
                                        control={control}
                                        name={"address"}
                                        render={({ field }) => (
                                            <textarea
                                                {...field}
                                                className="jobPostingTextAreas"
                                                placeholder="Enter address"
                                                style={{ width: '100%', resize: 'none' }}
                                            />
                                        )}
                                    />
                                    {errors?.address && (
                                        <div style={{ color: 'red', fontSize: '0.8rem' }}>
                                            {errors?.address?.message}
                                        </div>
                                    )}
                                </div>
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>City <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    control={control}
                                    name={"city"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter city"
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.city ? errors?.city?.message : ""}
                                        />
                                    )}
                                />
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>State <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    control={control}
                                    name={"state"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter state"
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.state ? errors?.state?.message : ""}
                                        />
                                    )}
                                />
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Pincode <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    control={control}
                                    name={"pincode"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            type="text"
                                            className="textfields"
                                            placeholder="Enter pincode"
                                            inputProps={{
                                                maxLength: 6,
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*'
                                            }}
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.pincode ? errors?.pincode?.message : ""}
                                        />
                                    )}
                                />

                            </Grid2>
                        </Grid2> */}

            {/* Sub container 2 */}
            {/* <Grid2 item container rowGap={2} sx={{ display: 'flex', flexDirection: 'column', width: !isSmallScreen ? '40%' : '100%', marginTop: isSmallScreen && '20px' }}>
                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Email <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    control={control}
                                    name={"email"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter email"
                                            onChange={(e) => {
                                                field.onChange(e);
                                                trigger('alternateEmail')
                                            }}
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.email ? errors?.email?.message : ""}
                                        />
                                    )}
                                />
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Contact Number <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    control={control}
                                    name={"contactNumber"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter contact number"
                                            onChange={(e) => {
                                                field.onChange(e); // update field value
                                                trigger('alternateNumber'); // manually trigger validation of alternate number
                                            }}
                                            type="number"
                                            inputProps={{ maxLength: 10, inputMode: 'numeric', pattern: '[0-9]*' }}
                                            sx={{
                                                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                },
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.contactNumber ? errors?.contactNumber?.message : ""}
                                        />
                                    )}
                                />
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : 'block', alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>
                                    Gender <span style={{ color: 'red' }}>*</span>
                                </InputLabel>
                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <Controller
                                        control={control}
                                        name="gender"
                                        render={({ field }) => (
                                            <Dropdown
                                                {...field}
                                                className="dropdown"
                                                displayEmpty
                                                placeholder="Select gender"
                                                valueKey="id"
                                                labelKey="label"
                                                options={genderOptions || []}
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        color: 'red',
                                                        marginLeft: '-1px'
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    {errors?.gender?.message && (
                                        <span style={{ color: 'red', fontSize: '0.8rem' }}>
                                            {errors?.gender?.message}
                                        </span>
                                    )}
                                </Box>
                            </Grid2>

                            <Grid2 item sx={{ alignItems: 'center', display: !isSmallScreen ? 'flex' : 'block' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Date of Birth <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    name="dateOfBirth"
                                    control={control}
                                    render={({ field }) => (
                                        <MuiDatePicker
                                            {...field}
                                            value={field.value ? dayjs(field.value) : null}
                                            onChange={(date) => field.onChange(date)}
                                            slotProps={{ textField: { error: !!errors.dateOfBirth, helperText: errors.dateOfBirth?.message, FormHelperTextProps: { sx: { color: 'red !important' } } } }}
                                        />
                                    )}
                                />
                            </Grid2>


                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>
                                    Password <span style={{ color: 'red' }}>*</span>
                                </InputLabel>
                                <Controller
                                    control={control}
                                    name={"password"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter password"
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            autoComplete="new-password"
                                            helperText={errors?.password ? errors?.password?.message : ""}
                                            type={showPassword ? 'text' : 'password'}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label={showPassword ? 'hide the password' : 'display the password'}
                                                            onClick={handleClickShowPassword}
                                                            edge="end"
                                                        >
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid2>


                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Confirm Password <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    control={control}
                                    name={"confirmPassword"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter confirm password"
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            autoComplete="new-password"
                                            helperText={errors?.confirmPassword ? errors?.confirmPassword?.message : ""}
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label={showConfirmPassword ? 'hide the password' : 'display the password'}
                                                            onClick={handleClickShowConfirmPassword}
                                                            edge="end"
                                                        >
                                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Alternate Number</InputLabel>
                                <Controller
                                    control={control}
                                    name={"alternateNumber"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            type="number"
                                            placeholder="Enter alternate number"
                                            inputProps={{ maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*' }}
                                            sx={{
                                                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                },
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.alternateNumber ? errors?.alternateNumber?.message : ""}
                                        />
                                    )}
                                />
                            </Grid2>

                            <Grid2 item sx={{ display: !isSmallScreen ? 'flex' : "", alignItems: 'center' }}>
                                <InputLabel className="inputlabels" sx={{ width: '55%' }}>Alternate Email</InputLabel>
                                <Controller
                                    control={control}
                                    name={"alternateEmail"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            className="textfields"
                                            placeholder="Enter alternate email"
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    color: 'red',
                                                    marginLeft: '-1px'
                                                }
                                            }}
                                            helperText={errors?.alternateEmail ? errors?.alternateEmail?.message : ""}
                                        />
                                    )}
                                />

                            </Grid2>

                        </Grid2> */}
            <Grid2 item className="signUpButtonContainer">
              <Typography
                sx={{
                  width: "50%",
                  textAlign: "center",
                  fontSize: "14px",
                  color: "#2f353a",
                }}
              >
                By clicking register, you agree to the open recruiter{" "}
                <span style={{ color: "#007ad9" }}>
                  {" "}
                  user agreement, privacy policy
                </span>
                , and <span style={{ color: "#007ad9" }}>cookie policy</span>.
              </Typography>
              <div style={{ display: "flex", gap: "25px", marginTop: "25px" }}>
                <MUIButton title="Register" type="Submit" />
                <MuiCancelButton title="Cancel" component={Link} to="/" />
              </div>
              <Typography sx={{ fontSize: "14px", marginTop: "10px" }}>
                Already an Open Recruiter?{" "}
                <span
                  style={{ color: "#007ad9", cursor: "pointer" }}
                  onClick={() => navigate("/")}
                >
                  Sign In
                </span>
              </Typography>
            </Grid2>
          </Grid2>
        </Box>
      </form>
    </Box>
  );
};

export default SignUp;
